import React from 'react';
import { Btn } from './ui/Card';

const STEPS = [
  { key: 'enrolled',   icon: '📝', label: 'Enregistrement',             desc: 'Fiche créée',                      color: '#6366f1' },
  { key: 'evaluated',  icon: '🎯', label: 'Évaluation des compétences', desc: 'Profil validé',                    color: '#0ea5e9' },
  { key: 'assigned',   icon: '📋', label: 'Affectation activité',       desc: 'Notification automatique envoyée', color: '#f59e0b' },
  { key: 'active',     icon: '🤝', label: 'Participation',              desc: 'Présence enregistrée',             color: '#10b981' },
  { key: 'feedback',   icon: '💬', label: 'Feedback',                   desc: "Évaluation de l'activité",         color: '#8b5cf6' },
  { key: 'recognized', icon: '🏅', label: 'Reconnaissance',             desc: 'Attestation PDF générée',          color: '#c9a84c' },
];

function generateAttestation(volontaire) {
  const date = new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
  const skills = Array.isArray(volontaire.skills)
    ? volontaire.skills
    : (volontaire.skills ? String(volontaire.skills).split(',').map(s => s.trim()).filter(Boolean) : []);

  const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<title>Attestation — ${volontaire.first_name} ${volontaire.last_name}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Inter:wght@400;500;600&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', sans-serif; background: white; }
  @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } @page { margin: 0; } }
  .page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 18mm 20mm; display: flex; flex-direction: column; }
  .outer { border: 7px solid #0f2044; border-radius: 10px; padding: 28px; flex: 1; display: flex; flex-direction: column; }
  .inner { border: 2px solid #c9a84c; padding: 28px 36px; flex: 1; display: flex; flex-direction: column; align-items: center; }
  .org { text-align: center; margin-bottom: 18px; }
  .org-name { font-family: 'Playfair Display', serif; font-size: 26px; color: #0f2044; font-weight: 700; }
  .org-sub { font-size: 11px; color: #6b7280; letter-spacing: 0.12em; text-transform: uppercase; margin-top: 5px; }
  .divider { width: 80px; height: 3px; background: #c9a84c; margin: 16px auto; border-radius: 2px; }
  .attest-title { font-family: 'Playfair Display', serif; font-size: 34px; color: #0f2044; text-align: center; }
  .attest-sub { font-size: 12px; color: #9ca3af; letter-spacing: 0.18em; text-transform: uppercase; margin-top: 6px; text-align: center; }
  .body { font-size: 15px; line-height: 1.9; color: #374151; text-align: center; margin: 28px 0; max-width: 440px; }
  .name { font-family: 'Playfair Display', serif; font-size: 30px; color: #0f2044; display: block; margin: 12px 0; }
  .gold { color: #a8883a; font-weight: 600; }
  .skills { display: flex; flex-wrap: wrap; gap: 7px; justify-content: center; margin: 14px 0; }
  .skill { background: rgba(201,168,76,0.12); border: 1px solid #c9a84c; color: #a8883a; padding: 4px 13px; border-radius: 20px; font-size: 12px; font-weight: 600; }
  .quote { font-style: italic; font-size: 13px; color: #9ca3af; margin-top: 10px; }
  .footer { margin-top: auto; width: 100%; display: flex; justify-content: space-between; align-items: flex-end; padding-top: 24px; border-top: 1px solid #e5e7eb; }
  .sig { text-align: center; }
  .sig-line { width: 130px; border-bottom: 1px solid #374151; margin: 36px auto 7px; }
  .sig-lbl { font-size: 11px; color: #6b7280; text-transform: uppercase; letter-spacing: 0.08em; }
  .seal { width: 72px; height: 72px; border-radius: 50%; border: 3px double #0f2044; display: flex; align-items: center; justify-content: center; margin: 0 auto; }
  .seal-txt { font-size: 9px; text-transform: uppercase; color: #0f2044; font-weight: 700; text-align: center; line-height: 1.4; }
  .date-info { font-size: 12px; color: #6b7280; text-align: right; line-height: 1.8; }
</style>
</head>
<body onload="window.print()">
<div class="page">
  <div class="outer">
    <div class="inner">
      <div class="org">
        <div class="org-name">LHM Madagascar</div>
        <div class="org-sub">Lumière pour les Hommes de Madagascar</div>
      </div>
      <div class="divider"></div>
      <div class="attest-title">Attestation de Volontariat</div>
      <div class="attest-sub">Certificat de reconnaissance officiel</div>
      <div class="body">
        Nous, soussignés, attestons que
        <span class="name">${volontaire.first_name} ${volontaire.last_name}</span>
        a accompli avec <span class="gold">dévouement et fidélité</span> son engagement
        en tant que volontaire au sein de l'organisation LHM Madagascar,
        en parcourant l'intégralité du cycle de vie du volontariat.
        ${skills.length ? `<div class="skills">${skills.map(s => `<span class="skill">${s}</span>`).join('')}</div>` : ''}
        ${volontaire.motivation ? `<div class="quote">"${volontaire.motivation}"</div>` : ''}
      </div>
      <div class="footer">
        <div class="sig">
          <div class="seal"><div class="seal-txt">LHM<br>Madagascar</div></div>
          <div style="margin-top:6px;font-size:10px;color:#9ca3af;">Cachet officiel</div>
        </div>
        <div class="date-info">
          <div>Délivré le <strong>${date}</strong></div>
          <div style="font-size:10px;color:#d1d5db;margin-top:3px;">Réf. ${volontaire.id || 'VOL-' + Date.now()}</div>
        </div>
        <div class="sig">
          <div class="sig-line"></div>
          <div class="sig-lbl">Direction Générale</div>
        </div>
      </div>
    </div>
  </div>
</div>
</body>
</html>`;

  const w = window.open('', '_blank', 'width=900,height=750');
  if (w) { w.document.write(html); w.document.close(); }
}

export default function VolontaireWorkflow({ volontaire, canEdit, onAdvance, onClose }) {
  const currentIdx = STEPS.findIndex(s => s.key === volontaire?.status);
  const isLast = currentIdx === STEPS.length - 1;
  const nextStep = !isLast && currentIdx >= 0 ? STEPS[currentIdx + 1] : null;

  return (
    <div style={{ padding: '24px 28px' }}>
      {/* Volunteer header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 28, padding: '14px 18px', background: 'var(--gray-50)', borderRadius: 12, border: '1px solid var(--gray-200)' }}>
        <div style={{ width: 46, height: 46, borderRadius: '50%', background: 'var(--navy)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: 700, flexShrink: 0, letterSpacing: '-0.5px' }}>
          {volontaire?.first_name?.[0]}{volontaire?.last_name?.[0]}
        </div>
        <div style={{ flex: 1 }}>
          <p style={{ fontWeight: 700, color: 'var(--navy)', fontSize: '0.95rem' }}>{volontaire?.first_name} {volontaire?.last_name}</p>
          <p style={{ fontSize: '0.75rem', color: 'var(--gray-500)', marginTop: 2 }}>{volontaire?.phone || volontaire?.email || ''}</p>
        </div>
        {isLast && (
          <span style={{ background: 'rgba(201,168,76,0.15)', color: 'var(--gold-dark)', padding: '4px 12px', borderRadius: 20, fontSize: '0.72rem', fontWeight: 700 }}>
            ✓ Parcours complet
          </span>
        )}
      </div>

      {/* Stepper */}
      <div>
        {STEPS.map((step, idx) => {
          const isDone    = idx < currentIdx;
          const isCurrent = idx === currentIdx;

          return (
            <div key={step.key} style={{ display: 'flex', gap: 14 }}>
              {/* Timeline column */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: isDone ? '0.95rem' : '1rem',
                  background: isDone || isCurrent ? step.color : 'white',
                  border: `2.5px solid ${isDone || isCurrent ? step.color : 'var(--gray-300)'}`,
                  color: isDone || isCurrent ? 'white' : 'var(--gray-400)',
                  boxShadow: isCurrent ? `0 0 0 5px ${step.color}22` : 'none',
                  zIndex: 1,
                }}>
                  {isDone ? '✓' : step.icon}
                </div>
                {idx < STEPS.length - 1 && (
                  <div style={{ width: 2, flex: 1, minHeight: 24, background: isDone ? step.color : 'var(--gray-200)', margin: '3px 0' }} />
                )}
              </div>

              {/* Content card */}
              <div style={{ flex: 1, paddingBottom: idx < STEPS.length - 1 ? 8 : 0 }}>
                <div style={{
                  padding: '10px 14px', borderRadius: 9, marginBottom: 4,
                  background: isCurrent ? `${step.color}0e` : isDone ? 'var(--gray-50)' : 'transparent',
                  border: `1.5px solid ${isCurrent ? `${step.color}35` : isDone ? 'var(--gray-200)' : 'transparent'}`,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                    <span style={{ fontSize: '0.83rem', fontWeight: 700, color: isDone ? 'var(--gray-600)' : isCurrent ? step.color : 'var(--gray-300)' }}>
                      {idx + 1}. {step.label}
                    </span>
                    {isCurrent && (
                      <span style={{ background: step.color, color: 'white', fontSize: '0.62rem', padding: '2px 7px', borderRadius: 20, fontWeight: 700, letterSpacing: '0.04em' }}>
                        EN COURS
                      </span>
                    )}
                    {isDone && <span style={{ color: step.color, fontSize: '0.72rem', fontWeight: 600 }}>Complété</span>}
                  </div>
                  <p style={{ fontSize: '0.75rem', color: isDone ? 'var(--gray-500)' : isCurrent ? 'var(--gray-600)' : 'var(--gray-300)', margin: '3px 0 0' }}>
                    {step.desc}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20, paddingTop: 18, borderTop: '1px solid var(--gray-200)', flexWrap: 'wrap' }}>
        {isLast && (
          <Btn variant="gold" onClick={() => generateAttestation(volontaire)}>
            📄 Générer l'attestation PDF
          </Btn>
        )}
        {canEdit && !isLast && nextStep && (
          <Btn variant="success" onClick={() => onAdvance(volontaire.id)}>
            Avancer vers "{nextStep.label}" ▶
          </Btn>
        )}
        <Btn variant="secondary" onClick={onClose}>Fermer</Btn>
      </div>
    </div>
  );
}
